import { render, staticRenderFns } from "./SearchModalDisplay.vue?vue&type=template&id=8093ea80&scoped=true"
import script from "./SearchModalDisplay.vue?vue&type=script&lang=js"
export * from "./SearchModalDisplay.vue?vue&type=script&lang=js"
import style0 from "./SearchModalDisplay.vue?vue&type=style&index=0&id=8093ea80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8093ea80",
  null
  
)

export default component.exports